export function cleanupStorage(storage, { prefixesToKeep = [], exactKeysToKeep = [] } = {}) {
  const exactSet = new Set(exactKeysToKeep);
  const keysToRemove = [];

  for (let i = 0; i < storage.length; i++) {
    const key = storage.key(i);

    const keepByPrefix = prefixesToKeep.some(prefix => key.startsWith(prefix));
    const keepExact = exactSet.has(key);

    if (!(keepByPrefix || keepExact)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach(key => storage.removeItem(key));
}
